import type { FieldValues, Path, UseFormReturn } from "react-hook-form";
import { Slider } from "./slider.core";
import { FormControl, FormField, FormItem } from "../../../components/ui/form";

type FormRangeProps<T extends FieldValues> = {
  form: UseFormReturn<T>;
  name: Path<T>;
  min?: number;
  max: number;
  onValueChange?: (value: number) => void;
  className?: string;
  step?: number;
  decimalPlaces?: number;
  valueType?: "decimal" | "integer" | "percentage"; // Add valueType prop
};

export const FormRange = <T extends FieldValues>({
  form,
  name,
  min = 0.001,
  max,
  onValueChange,
  className,
  step = 0.001,
  decimalPlaces = 3,
  valueType = "integer", // Default to integer
}: FormRangeProps<T>) => {
  return (
    <FormField
      control={form.control}
      name={name}
      render={({ field }) => (
        <FormItem>
          <FormControl>
            <Slider
              stepsVisible={true}
              overLabelVisible={true}
              value={[Number.parseFloat(field.value?.toString() || "0")]}
              onValueChange={(values) => {
                const newValue = Number.parseFloat(values[0].toString());
                field.onChange(newValue);
                if (onValueChange) {
                  onValueChange(newValue);
                }
              }}
              max={max}
              min={min}
              step={step}
              decimalPlaces={decimalPlaces}
              valueType={valueType} // Pass valueType to Slider
              className={className}
            />
          </FormControl>
        </FormItem>
      )}
    />
  );
};
